(ns kyber.styles.border-radius)

(def border-radius
  {:r0 "0"
   :r3 "3px"
   :r7 "7px"
   :r40 "40px"
   :rfull "9999px"})
